module.exports = __webpack_public_path__ + "img/close.770a86e8.png";